import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';

export type DiscoveryRuleModalProps = {
    data: {
        mode: string,
        source: string,
        tasks: number,
        events: number,
        discovery_rule_id: number,
        discovery_rule: string,
        category: string,
        calculate_cost_impact: boolean;
        filters : any,
        filterSummary : any,
        automation_opportunity : any,
        type: string,
        discovery_rule_type: string,
        save_activities: boolean,
        save_steps: boolean,
        save_variants: boolean,
        filter_activities: string,
        filter_variants: string,
        filter_steps: string,
    }
}


export const openDiscoveryRuleModal = ({ data }:  DiscoveryRuleModalProps) => {
    getEventEmitter().emit(Event.openDiscoveryRuleModal, { data });
};

